import React, { useState, useContext, useRef, useEffect } from "react";
import DataTable from "../../../../common/DataTable";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import StockReport from "./StockReport";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  searchedShowingData,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
  checkPermission
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { MdDelete } from 'react-icons/md';

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import ViewAccountSheet from "../../accounts/transactions/ViewAccountSheet"

const SaleReturnList = () => {
  const { t } = useTranslation();

  let {
    //purchase order
    getPaginatedReturnOrder,
    setSaleReturnList,
    setSaleReturnForSearch,
    saleReturnForSearch,
    saleReturnList,
    
    //common
    loading,
    setLoading,

    //pagination
    dataPaginating,
    setDataPaginating,
  } = useContext(RestaurantContext);

  let { authUserInfo, } = useContext(UserContext);
  // States hook here
  const [btnDisable, setBtnDisable] = useState("");

  const [ledgerData, setLedgerData] = useState({
    modal: false,
    ledger: null
  })

  //search result
  let [searchedSupplier, setSearchedSupplier] = useState({
    list: null,
    searched: false,
  });

  const searchRef = useRef(null);

  useEffect(()=>{
    getPaginatedReturnOrder(1)
  },[])

  //search purchase here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedSupplier({ ...searchedSupplier, searched: false });
    } else {
      const searchedList = saleReturnForSearch.filter((item) => {
        //name
        let lowerCaseItemSupplierName = item.supplier_name.toLowerCase();
        //email
        let lowerCaseItemInvoice = item.invoice_number !== null && item.invoice_number.toLowerCase();
        let lowerCaseBranch = item.branch?.name && item.branch.name.toLowerCase();

        return (
          lowerCaseItemSupplierName.includes(searchInput) ||
          lowerCaseItemInvoice.includes(searchInput) ||
          lowerCaseBranch.includes(searchInput)
        );
      });
      setSearchedSupplier({
        ...searchedSupplier,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeletePurchase(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete purchase here
  const handleDeletePurchase = (id) => {
    setLoading(true);
    const url = BASE_URL + `/settings/sale-return/${id}`;
    return axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {

        setSaleReturnList(res.data[0]);
        setSaleReturnForSearch(res.data[1]);
        setSearchedSupplier({
          ...searchedSupplier,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Sale return has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //print bills states and function
  const [newRow,setNewRow]=useState([]);
  const [purchaseDate,setPurchaseDate]=useState(new Date());
  let [newItem, setNewItem] = useState({
    branch: null,
    customer: null,
    invoice: "",
    description: "",
    paymentType: "",
  });
  const componentRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: "@page { margin: 15px }"
  });

  const handlePiLedger = async(id) =>{
    const url = BASE_URL + "/settings/check-financial-ledger-view/" + parseInt(id) + "/SI";
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLedgerData({ modal: true, ledger: res.data});
      }
    }catch(err){
      console.log("error==>",err)
    }
  }
  
  const handleGetPrintData = async(id) => {
    const url = BASE_URL + "/settings/sale-return/" + parseInt(id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
          if(res.data){
            let purchaseDate = new Date(res.data.document_date);
            setPurchaseDate(purchaseDate);
            setNewItem({
              ...newItem,
              branch: res.data.branch,
              description:res.data.desc,
              paymentType:res.data.payment_type,
              paid_amount: res.data.paid_amount,
              customer: {
                id: res.data.customer_id,
                name: res.data.customer_name
              },
              invoice:res.data.document_identity,
              total_amount: res.data.total_amount,
              total_discount: res.data.total_discount,
              total_tax: res.data.total_tax,
              total_bill: res.data.total_bill,
            })
            if(res.data.sale_return_detail){
              setNewRow([...res.data.sale_return_detail])
            }
          }
          handleOnlyPrint();
          
    } catch(error) {
      console.log("error==>",error)
    }
  }

  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return rate * qty;
  };

  //post button function
  const handlePostApi = async (item) => {
    // setDataPaginating(true);
    const url = BASE_URL + "/settings/mark-is-post-sale-return"
    let formData = new FormData();
    setBtnDisable(item.id)
    formData.append('id',item.id)
    formData.append('is_post', item.is_post ? 0 : 1)
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
        if(res.data){
          setBtnDisable("")
          setSaleReturnList(res.data[0]);
          setSaleReturnForSearch(res.data[1]);
          setSearchedSupplier({
            ...searchedSupplier,
            list: res.data[1],
          });
          toast.success(`${_t(t(item?.is_post ? "Sale return has been unpost" : "Sale return has been post"))}`,{
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
        setDataPaginating(false);
    } catch(err) {
      setDataPaginating(false);
      setBtnDisable("")
      if(err.response?.data?.status === "error"){
        toast.error(`${_t(t(err.response.data.message))}`,{
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      toast.error(`${_t(t("Please try again"))}`,{
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  //unpost confirmation modal
  const handleUnPostConfirmation = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body px-5">
            <h3>{_t(t("Are you sure?"))}</h3>
            <p className="text-center">{_t(t("You want to un post this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handlePostApi(item);
                  onClose();
                }}
              >
                {_t(t("Yes, unpost it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleFetchData =(page) => {
    getPaginatedReturnOrder(page);
  };

  const onClearSearch = () => {
    setSearchedSupplier({ ...searchedSupplier, searched: false });
    if (searchRef.current) {
      searchRef.current.value = "";
    }
  };

  const getListData = () => {
    if (searchedSupplier.searched) {
      return searchedSupplier.list;
    }
    return saleReturnList?.data || [];
  };

  const COLUMNS = [
    {
      label: _t(t("S/L")),
      key: "sl",
      render: (item, index,) => {
        return index + 1 + (saleReturnList?.currentPage - 1) * saleReturnList?.perPage;
      }
    },
    { label: _t(t("Customer")), key: "customer_name" },
    { label: _t(t("Invoice")), key: "document_identity" },
    {
      label: _t(t("Purchased")),
      key: "purchase_date",
      render: (item) => <Moment format="DD-MMMM-YYYY">{item.purchase_date}</Moment>
    },
    {
      label: _t(t("Branch")),
      key: "branch_name",
      render: (item) => item.branch?.name ?? ""
    },
    {
      label: _t(t("Total")),
      key: "total_bill",
      render: (item) => (
        <>
          {currencySymbolLeft()}
          {formatPrice(item.total_bill)}
          {currencySymbolRight()}
        </>
      )
    },
    {
      label: _t(t("Action")),
      key: "action",
      render: (item) => (
        <div className="d-flex justify-content-center">
          {item.is_post !== 1 && (
            <NavLink
              title="Edit"
              disabled={item.id === btnDisable}
              className="btn btn-primary ml-2 rounded-sm del-btn"
              to={`/dashboard/manage/stock/sale-return-edit/${item.id}`}
              style={{ height: "1.7rem", width: "1.7rem" }}
            >
              <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
            </NavLink>
          )}
          {item.is_post !== 1 && (
            <button
              disabled={item.id === btnDisable}
              className="btn btn-danger ml-2 rounded-sm del-btn"
              onClick={() => handleDeleteConfirmation(item.id)}
            >
              <MdDelete className="del-icon" />
            </button>
          )}
          <button
            className="btn btn-secondary ml-2 rounded-sm del-btn"
            onClick={() => handleGetPrintData(item.id)}
          >
            <i className="fa fa-print edit-icon"></i>
          </button>
          {checkPermission(authUserInfo.permissions, "PI Post") && item.is_post !== 1 ? (
            <button
              className="btn btn-dark ml-2 rounded-sm del-btn"
              title="Post SR"
              style={{ padding: "1px 0px 0px 1px" }}
              disabled={loading || item.id === btnDisable}
              onClick={() => handlePostApi(item)}
            >
              <i className="fa fa-check-square-o" aria-hidden="true"></i>
            </button>
          ) : null}
          {checkPermission(authUserInfo.permissions, "PI Post") &&
          authUserInfo?.details?.user_type === "superAdmin" &&
          item.is_post === 1 ? (
            <button
              className="btn btn-warning ml-2 rounded-sm del-btn"
              title="Unpost SR"
              style={{ padding: "1px 0px 0px 1px" }}
              disabled={loading || item.id === btnDisable}
              onClick={() => handleUnPostConfirmation(item)}
            >
              <i className="fa fa-check-square-o" aria-hidden="true"></i>
            </button>
          ) : null}
        </div>
      )
    },
    {
      label: _t(t("Created Date")),
      key: "created_at",
      render: (item) => <Moment format="DD-MMMM-YYYY hh:mm A">{item.created_at}</Moment>
    },
    {
      label: _t(t("Created By")),
      render: (item) => <>{item?.created_by_name || "-"}</>
    },
    {
      label: _t(t("Updated By")),
      render: (item) => <>{item?.updated_by_name || "-"}</>
    },
    {
      label: _t(t("Posted By")),
      render: (item) => <>{item?.post_by_name || "-"}</>
    },
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Sale Return"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div key="fragment3">
                  <div className="row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                      <ul className="t-list fk-breadcrumb">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-capitalize">
                            {!searchedSupplier.searched
                              ? _t(t("Sales Return List"))
                              : _t(t("Search Result"))}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6 col-lg-7">
                      <div className="row gx-3 align-items-center">
                        {/* Search customer */}
                        <div className="col-md-9 t-mb-15 mb-md-0">
                          <div className="input-group">
                            <div className="form-file">
                              <input
                                type="text"
                                className="form-control border-0 form-control--light-1 rounded-left"
                                placeholder={_t(t("Search")) + ".."}
                                onChange={handleSearch}
                              />
                            </div>
                            <button
                              className="btn btn-primary rounded-right"
                              type="button"
                            >
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>

                        {/* Add customer modal trigger button */}
                        <div className="col-md-3 text-md-right">
                          <NavLink
                            to="/dashboard/manage/stock/sale-return-add"
                            className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                          >
                            {_t(t("add new"))}
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table */}
                  <DataTable
                    loading={loading || dataPaginating}
                    data={getListData()}
                    columns={COLUMNS}
                    emptyText="No data available"
                    pagination={{
                      isPageLoading: loading,
                      isPagination: true,
                      pageCount: saleReturnList?.last_page,
                      currentPage: saleReturnList?.current_page,
                      from: saleReturnList?.from,
                      to: saleReturnList?.to,
                      total: saleReturnList?.total,
                    }}
                    handleFetchData={handleFetchData}
                    searchPayload={{
                      isSearched: searchedSupplier.searched,
                      onClearSearch
                    }}
                  />
                </div>                    
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <StockReport
        name = "Sale Return"
        purchaseDate={purchaseDate}
        newItem={newItem}
        newRow={newRow}
        invoiceNo = {"Invoice No"}
        inoviceDate = {"Invoice Date"}
        handleGetTotal={""}
        handleAmount={""}
        handleTaxAmount={""}
        handleDisAmount={""}
        handleGetSubTotal={""}
        handleGetAmount={handleGetAmount}
        stockPrint={componentRef}
      /> 
      <ViewAccountSheet
        accountLedger={ledgerData}
        setAccountLedger= {setLedgerData}
      />
    </>
  );
};

export default SaleReturnList;
